

import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './TimesheetExport.css'; // Optional for styli
import { useAuth } from '../../AuthProvider';
import { ConsoleLogger } from 'aws-amplify/utils';
import { baseUrl_SPB } from '../../BaseUrl';


function XeroTimesheetExport(props) {

  const [frequency, setFrequency] = useState('Fortnightly');
  const [payPeriodStart, setPayPeriodStart] = useState(new Date());
  const [payPeriodEnd, setPayPeriodEnd] = useState(new Date());
  const [payDate, setPayDate] = useState(new Date());
  const [payCalendarId, setPayCalendarId] = useState('');
  const [errMsg,setErrMsg] = useState('');
  const authContext = useAuth();
  const handleTrigger = () => {
    
  };

  const handleExportClick = async () => {
    const xeroAccessToken = sessionStorage.getItem('xero_access_token');
    console.log('Xero Access Token:', xeroAccessToken);
    const tenantId = sessionStorage.getItem('tenant_id');
    console.log('Tenant ID:', tenantId);
    try {
        const formattedPayPeriodStart = format(payPeriodStart, 'yyyy-MM-dd');
        const formattedPayPeriodEnd = format(payPeriodEnd, 'yyyy-MM-dd');
        const formattedPayDate = format(payDate, 'yyyy-MM-dd');
      const response = await fetch(`${baseUrl_SPB}/api/v1/xero/timesheet/export/${props.additionalUserInfo.companyId}/${formattedPayPeriodStart}/${formattedPayPeriodEnd}/${payCalendarId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authContext.token, // Assumes authContext is defined and holds a token
        },
        body: JSON.stringify({
          xeroAccessToken: xeroAccessToken,
          tenantId: tenantId // Assumes xeroAccessToken is defined
        })
      });

      
     
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Export response:', data);  
      if(data.message || data.body.message){
        setErrMsg(data.message || data.body.message);
       // console.error('Error from server:', data.body.message);
       // throw new Error(data.message);
      }
    
    } catch (error) {
     // console.error('Export failed:', error);
  
    }
  };

  const handleExportLeaveClick = async () => {
    const xeroAccessToken = sessionStorage.getItem('xero_access_token');
    console.log('Xero Access Token:', xeroAccessToken);
    const tenantId = sessionStorage.getItem('tenant_id');
    console.log('Tenant ID:', tenantId);
    try {
        const formattedPayPeriodStart = format(payPeriodStart, 'yyyy-MM-dd');
        const formattedPayPeriodEnd = format(payPeriodEnd, 'yyyy-MM-dd');
        const formattedPayDate = format(payDate, 'yyyy-MM-dd');
      const response = await fetch(`${baseUrl_SPB}/api/v1/xero/leave/export/${props.additionalUserInfo.companyId}/${formattedPayPeriodStart}/${formattedPayPeriodEnd}/${payCalendarId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authContext.token, // Assumes authContext is defined and holds a token
        },
        body: JSON.stringify({
          xeroAccessToken: xeroAccessToken,
          tenantId: tenantId // Assumes xeroAccessToken is defined
        })
      });

      
     
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Export response:', data);  
      if(data.message || data.body.message){
        setErrMsg(data.message || data.body.message);
       // console.error('Error from server:', data.body.message);
       // throw new Error(data.message);
      }
    
    } catch (error) {
     // console.error('Export failed:', error);
  
    }
  };

  return (
    <div>
      <div className="trigger-payrun-container">
        <h2>Trigger Timesheet export (please ensure pay period and Pay Calendar ID are the same as Xero)</h2>
        {errMsg && <div className="error-message" style={{color:'red'}}>Erro: {errMsg}</div>}
        <div className="form-group">
          <label>Pay Frequency</label>
          <select value={frequency} onChange={(e) => setFrequency(e.target.value)}>
            <option value="Weekly">Weekly</option>
            <option value="Fortnightly">Fortnightly</option>
            <option value="Monthly">Monthly</option>
          </select>
        </div>

        <div className="form-group">
          <label>Pay Period Start</label>
          <DatePicker
            selected={payPeriodStart}
            onChange={date => setPayPeriodStart(date)}
            dateFormat="yyyy-MM-dd"
          />
        </div>

        <div className="form-group">
          <label>Pay Period End</label>
          <DatePicker
            selected={payPeriodEnd}
            onChange={date => setPayPeriodEnd(date)}
            dateFormat="yyyy-MM-dd"
          />
        </div>

        <div className="form-group">
          <label>Pay Date</label>
          <DatePicker
            selected={payDate}
            onChange={date => setPayDate(date)}
            dateFormat="yyyy-MM-dd"
          />
        </div>

        <div className="form-group">
          <label>Pay Calendar ID</label>
          <input
            type="text"
             onChange={(event) => setPayCalendarId(event.target.value)}
            value={payCalendarId}
            />
        </div>

      <button onClick={handleExportClick}>Export Timesheet</button>
      {/* <button onClick={handleExportLeaveClick}>Export Leave</button> */}
      
      </div>
     
    </div>
  );
}

export default XeroTimesheetExport;
